interface ChatDotsProps {
  className?: string;
}

export default function ChatDots({ className }: ChatDotsProps) {
  return (
    <svg
      className={className}
      width="19"
      height="19"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 12C22 16.9706 17.5228 21 12 21C10.6698 21 9.40034 20.7663 8.23943 20.3419C8.01725 20.2607 7.90616 20.2201 7.81636 20.202C7.72851 20.1843 7.6635 20.1778 7.57348 20.1778C7.48145 20.1778 7.38121 20.1928 7.18072 20.2229L3.22751 20.8159C2.81354 20.878 2.60655 20.909 2.45687 20.8512C2.32587 20.8007 2.22148 20.7067 2.16529 20.5888C2.10109 20.4541 2.13559 20.2678 2.20459 19.8952L2.86345 16.3374C2.89687 16.1569 2.91357 16.0667 2.91356 15.9839C2.91355 15.9028 2.90635 15.8443 2.88666 15.7653C2.86653 15.6845 2.82142 15.5845 2.73118 15.3845C2.25971 14.3397 2 13.1971 2 12C2 7.02944 6.47715 3 12 3C17.5228 3 22 7.02944 22 12Z"
        stroke="#2C2C2C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="8" cy="12" r="1" fill="#2C2C2C" />
      <circle cx="12" cy="12" r="1" fill="#2C2C2C" />
      <circle cx="16" cy="12" r="1" fill="#2C2C2C" />
    </svg>
  );
}
